module.exports = __webpack_public_path__ + "img/logo-reinodelvalle-desktop.2dcb6994.svg";